import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showBanner } from '../../global-state/banner-slice'
import { faqServices, flattenFaqs, type FaqFlatRow } from '../../services/faq-service'
import { FaqListPresenter } from './faq-list-presenter'

export function FaqListContainer() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [items, setItems] = useState<FaqFlatRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const load = useCallback(async () => {
    try {
      setIsLoading(true)
      const data = await faqServices.list()
      setItems(flattenFaqs(data))
    } catch {
      dispatch(showBanner({ text: 'Failed to load FAQs', variant: 'error-banner' }))
      setItems([])
    } finally {
      setIsLoading(false)
    }
  }, [dispatch])

  useEffect(() => {
    void load()
  }, [load])

  const onDelete = async (id: number) => {
    if (!window.confirm('Delete this FAQ?')) return
    try {
      await faqServices.remove(id)
      dispatch(showBanner({ text: 'FAQ deleted', variant: 'success-banner' }))
      await load()
    } catch {
      dispatch(showBanner({ text: 'Delete failed', variant: 'error-banner' }))
    }
  }

  return (
    <FaqListPresenter
      items={items}
      isLoading={isLoading}
      onAdd={() => navigate('/faqs/new')}
      onEdit={(id) => navigate(`/faqs/${id}/edit`)}
      onDelete={onDelete}
    />
  )
}
